export default __webpack_public_path__ + "static/media/downloadWalletoff.a298644a.svg";